/** Class names for the department-report Layout and View toolbar. */
export const REPORT_TOOLBAR_CLASS = {
  root: "ntcog-report-toolbar",
  row: "ntcog-report-toolbar__row",
  control: "ntcog-report-toolbar__control",
  view: "ntcog-report-toolbar__control--view",
  week: "ntcog-report-toolbar__control--week",
  custom: "ntcog-report-toolbar__custom",
  hint: "ntcog-report-toolbar__hint",
  layoutSelect: "ntcog-report-toolbar__layout-select",
} as const;

/**
 * Toolbar width at and below which the pieces stack full width.
 * The container query in global.css repeats this length; a query cannot read this value.
 */
export const REPORT_TOOLBAR_STACK_MAX_PX = 576;
